import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../../providers/ApiProvider';

export function useSingleBusinessVerification({
  enabled = true,
  type,
  code,
}: {
  code: string;
  type: string;
  enabled?: boolean;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['business-merchant', 'documentation', code, type], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `business-merchant/${code}/documentation/${type}`,
      });
      return res;
    },
    enabled,
  });
}
